import { forEach, debounce } from 'lodash'
/**
 * 根據傳入的 生日(西元格式)計算保險年齡
 * @param birth
 * @returns
 */
export function getInsureAge (y, m, d) {
  const birthday = new Date(y, m, d)
  const today = new Date().setHours(0, 0, 0, 0)
  const currentYear = new Date().getFullYear()
  const bM = birthday.getMonth()
  const bD = birthday.getDate()
  const startDate = new Date(currentYear, bM + 6, bD)
  const endDate = new Date(currentYear, bM - 6, bD)
  var age = currentYear - birthday.getFullYear()
  if (today > startDate.getTime()) {
    age += 1
  }
  if (today <= endDate.getTime()) {
    age -= 1
  }
  return age
}

export function getInsureFutureAge (y, m, d, addDay) {
  const birthday = new Date(y, m, d)
  const currentYear = new Date().getFullYear()
  const now = new Date()
  const today = new Date(currentYear, now.getMonth(), now.getDate())
  today.setDate(today.getDate() + addDay)
  const bM = birthday.getMonth()
  const bD = birthday.getDate()
  const startDate = new Date(currentYear, bM + 6, bD)
  const endDate = new Date(currentYear, bM - 6, bD)
  var age = currentYear - birthday.getFullYear()
  if (today.getTime() > startDate.getTime()) {
    age += 1
  }
  if (today.getTime() <= endDate.getTime()) {
    age -= 1
  }
  return age
}

export function isWarraingAge (y, m, d, addDay) {
  for (let i = 1; i <= addDay; i++) {
    let age = getInsureAge(y, m, d)
    let age2 = getInsureFutureAge(y, m, d, i)
    if (age2 > age) {
      return i
    }
  }
  return 0
}

/**
 * 根據傳入的 生日(西元格式)計算實際年齡
 * @param birth
 * @returns
 */
export function getActualAge (y, m, d) {
  const thisYear = new Date().getFullYear()
  const thisYearBirthday = new Date(thisYear, m, d) // 今年生日時間
  const now = new Date()
  const today = new Date(thisYear, now.getMonth(), now.getDate())
  let age = thisYear - y
  if (today.getTime() < thisYearBirthday.getTime()) {
    // 未過生日
    age--
  }
  console.log('實際年紀:' + age)
  return age > 0 ? age : 0
}

/**
 * 保險年齡快到期的警示
 * @param birth
 * @returns
 */
export function getFutureAge (y, m, d, addDay) {
  const thisYear = new Date().getFullYear()
  const thisYearBirthday = new Date(thisYear, m, d) // 今年生日時間
  const now = new Date()
  const today = new Date(thisYear, now.getMonth(), now.getDate())
  today.setDate(today.getDate() + addDay)
  let diffTime = today.getTime() - thisYearBirthday.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

/**
 * 2020新外籍人士居留證驗證 (新)
 * @param pid 身分證字號
 * @return 是否正確
 */
export function verifyForeignId (pid) {
  if (!pid) return false
  pid = pid.trim()
  if (pid.length !== 10) return false
  const regexp = new RegExp(/^[a-zA-Z](8|9)\d{8}$/i)
  // const r = new RegExp(/^[A-Za-z][A-Da-d][\d]{8}$/i)
  if (!regexp.test(pid)) return false
  pid = pid.toUpperCase()

  const codes = '0123456789ABCDEFGHJKLMNPQRSTUVXYWZIO'
  var pidCodes = {}
  forEach(codes.split(''), function (v, i) {
    pidCodes[v] = i // 建立字母vs數字對照表
  })
  // 依據前9碼權重總合與最後檢核碼比較
  var sum = 0
  for (var i = 8; i > 0; i--) {
    sum += parseInt(pidCodes[pid.charAt(i)]) * (9 - i)
  }
  var checkDigit =
    10 -
    ((sum +
      (parseInt(pidCodes[pid.charAt(0)]) % 10) * 9 +
      parseInt(parseInt(pidCodes[pid.charAt(0)] / 10))) %
      10)
  return checkDigit % 10 === parseInt(pid.slice(-1))
}

/**
 * 身分證字號或外籍人士居留證驗證
 * 第一個字元代表地區，轉換方式為：A轉換成1,0兩個字元，B轉換成1,1……但是Z、I、O分別轉換為33、34、35
 * 第二個字元代表性別，1代表男性，2代表女性
 * 第三個字元到第九個字元為流水號碼。
 * 第十個字元為檢查號碼。
 * 每個相對應的數字相乘，如A123456789代表1、0、1、2、3、4、5、6、7、8，相對應乘上1987654321，再相加。
 * 相加後的值除以模數，也就是10，取餘數再以模數10減去餘數，若等於檢查碼，則驗證通過
 * @param pid 身分證字號
 * @return 是否正確
 */
export function verifyId (pid) {
  if (!pid) return false
  pid = pid.trim()
  if (pid.length !== 10) return false
  const regexp = new RegExp(/^[a-zA-Z](1|2)\d{8}$/i)
  // const r = new RegExp(/^[A-Za-z][A-Da-d][\d]{8}$/i)
  if (!regexp.test(pid)) return false
  pid = pid.toUpperCase()

  const codes = '0123456789ABCDEFGHJKLMNPQRSTUVXYWZIO'
  var pidCodes = {}
  forEach(codes.split(''), function (v, i) {
    pidCodes[v] = i // 建立字母vs數字對照表
  })
  // 依據前9碼權重總合與最後檢核碼比較
  var sum = 0
  for (var i = 8; i > 0; i--) {
    sum += parseInt(pidCodes[pid.charAt(i)]) * (9 - i)
  }
  var checkDigit =
    10 -
    ((sum +
      (parseInt(pidCodes[pid.charAt(0)]) % 10) * 9 +
      parseInt(parseInt(pidCodes[pid.charAt(0)] / 10))) %
      10)
  return checkDigit === parseInt(pid.slice(-1))
}

/**
 * @description 字串樣版插值
 * @example interpolate('This is a {template}', { template: 'book' }) => 'This is a book'
 * @param {string} template - strig template
 * @param {object} values - interpolate to template
 */
export const interpolate = (template, values) => {
  return template.replace(/\{([^}]+)\}/g, (_, p) => {
    return p in values ? values[p] : `{${p}}`
  })
}

// 日期物件格式化
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
export function dateFormatString (dateObj, fmt) {
  if (!dateObj || !(dateObj instanceof Date)) {
    return ''
  }
  var o = {
    'M+': dateObj.getMonth() + 1, // 月份
    'd+': dateObj.getDate(), // 日
    'h+': dateObj.getHours(), // 小時
    'm+': dateObj.getMinutes(), // 分
    's+': dateObj.getSeconds(), // 秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), // 季度
    S: dateObj.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    let yStrLen = RegExp.$1.length
    let yStr = ''
    if (yStrLen === 3) {
      // 民國年
      yStr = dateObj.getFullYear() - 1911 + ''
    } else {
      yStr = (dateObj.getFullYear() + '').substr(4 - yStrLen)
    }
    fmt = fmt.replace(RegExp.$1, yStr)
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

/** 檢核純英文字母
 * @param {String} str
 */
export const isAlphabet = (str = '') => {
  const regExp = /^[a-zA-Z]+$/
  return regExp.test(str)
}
/**
 * 檢核純數字
 * @param {String} str
 */
export const isNumeric = (str = '') => {
  const regExp = /^\d+$/
  return regExp.test(str)
}
/**
 * 檢核純英數混合(可以全英文或全數字)
 * @param {String} str
 */
export const isAlphanumeric = (str = '') => {
  const regExp = /^[\d|a-zA-Z]+$/
  return regExp.test(str)
}

/** 檢核強迫包含英數
 * @param {String} str
 */
export const isAlphaNum = (str = '') => {
  const regExp = /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/
  return regExp.test(str)
}
/** 強迫回傳數字
 * @param {String} str
 */
export const numberResult = num => {
  const s = []
  Array.from(num).forEach(e => {
    isNumeric(e) ? s.push(e) : s.push('')
  })
  return s.join('')
}
export const withDebounce = (
  fn,
  wait = 3000,
  options = {
    leading: true,
    trailing: false
  }
) => {
  return debounce(fn, wait, options)
}
export const getCookie = (name) => {
  let arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
  if (arr != null) {
    return unescape(arr[2])
  }
  return null
}

export const filterVaildLog = (str = '') => {
  let logStr = str.replaceAll("\r", "")
  logStr =  logStr.replaceAll("\n", "")
  logStr =  logStr.replaceAll("%0d", "")
  logStr =  logStr.replaceAll("%0a", "")
  return logStr;
}
